import { React, useCallback, useRef } from '@digsup/core-ui';
import { useFormikContext } from 'formik';
import debounce from 'just-debounce-it';
import PropTypes from 'prop-types';

const AutoSave = ({ debounceMs }) => {
  const formik = useFormikContext();
  const didMountRef = useRef(false);
  const debouncedSubmit = useCallback(
    debounce(
      // eslint-disable-next-line  no-return-assign
      () =>
        didMountRef.current
          ? formik.submitForm()
          : (didMountRef.current = true),
      debounceMs,
    ),
    [debounceMs, formik.submitForm],
  );

  React.useEffect(() => {
    debouncedSubmit();
  }, [debouncedSubmit, formik.values]);

  return <></>;
};

AutoSave.propTypes = { debounceMs: PropTypes.number };

AutoSave.defaultProps = { debounceMs: 100 };

export { AutoSave };
